import React from "react";
import "./dataSearchList.scss";

const CitySearchList = ({ data, onSelectDataHandler, setShowList, setDeliveryRefValue, setCityRefValue }) => {
    const addItemHandler = (item) => {
        onSelectDataHandler(item?.Present || item.Description);
        setShowList(false);
        setCityRefValue(item.Ref);

        if (item?.DeliveryCity) {
            setDeliveryRefValue(item.DeliveryCity);
        }
    };
    return (
        <div className="dataSearchList">
            <ul className="list-group">
                {data.map((item) => {
                    return (
                        <li
                            className="list-group-item custom-list-item"
                            key={item.id}
                            onClick={() => addItemHandler(item)}
                        >
                            {item.Present}
                            {item.Description}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default CitySearchList;
